module.exports = __webpack_public_path__ + "media/img/pages/companies/bdo-46e0e1f6fce25349c1dba6f2dd09e7a1.png";